(() => {
  if (window.vivaMegaMenuReady) return;
  window.vivaMegaMenuReady = true;

  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function bind(root = document) {
    root.querySelectorAll('.v-navigation--desktop details[data-viva-mega]').forEach(detail => {
      if (detail.dataset.vivaMegaBound) return;
      detail.dataset.vivaMegaBound = 'true';
      const summary = detail.querySelector('summary');

      detail.addEventListener('pointerenter', event => {
        if (!canHover.matches || event.pointerType !== 'mouse') return;
        detail.open = true;
        detail.dataset.vivaHoverOpen = 'true';
      });
      detail.addEventListener('pointerleave', () => {
        delete detail.dataset.vivaHoverOpen;
        if (!detail.contains(document.activeElement)) detail.open = false;
      });
      detail.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (!detail.contains(document.activeElement) && !detail.matches(':hover')) detail.open = false;
        });
      });
      summary?.addEventListener('click', event => {
        if (event.detail > 0 && detail.dataset.vivaHoverOpen === 'true') event.preventDefault();
      });
    });
  }

  bind();
  document.addEventListener('shopify:section:load', event => {
    bind(event.target);
  });
})();
